var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.xgId,style:({width:_vm.width+'px',height:_vm.height+'px'})})])}
var staticRenderFns = []

export { render, staticRenderFns }